import React, { Component } from 'react';

import { withStyles, createStyleSheet } from 'material-ui/styles';
import { TextField, List, CircularProgress } from 'components';

import debounce from 'lodash/debounce';

const styleSheet = createStyleSheet('SearchInput', theme => ({
  root: {
    width: '100%',
    background: theme.palette.background.paper,
    position: 'relative',
  },
  itemsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: `${theme.spacing.unit}px 0`,
  },
  list: {
    position: 'absolute',
    zIndex: 2,
    background: '#fff',
    border: '1px solid black',
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: 24,
    width: 200,
  },
  // listItemFocused: {
  //   textDecoration: 'none',
  //   backgroundColor: 'rgba(0, 0, 0, 0.12)',
  // }
}));

class SearchInput extends Component {
  static defaultProps = {
    focus: false,
    onSearch: () => {},
    dataSource: [],
    dataLoading: false,
    classes: {},
  };

  state = {
    value: '',
    error: false,
    items: [],
  };

  notifyChangeText = debounce(() => {
    this.props.onSearch(this.state.value);
  }, 200);

  notifyChangeItems = () => {
    this.props.onAddItems(this.state.items);
  };

  handleInputChange = event => {
    this.setState({ value: event.target.value }, this.notifyChangeText);
  };

  handleListItemClick = searchItem => () => {
    if (this.state.items.some(item => item.id === searchItem.id)) {
      return this.setState({
        value: '',
        error: true,
        errorMessage: '이미 추가 되었습니다.',
      });
    }

    this.setState(
      ({ items }) => ({
        items: [...items, searchItem],
        value: '',
        error: false,
        errorMessage: '',
      }),
      this.notifyChangeItems
    );
  };

  handleRemoveItem = searchItemId => event => {
    event.preventDefault();

    this.setState(
      ({ items }) => ({
        items: items.filter(item => item.id !== searchItemId),
      }),
      this.notifyChangeItems
    );
  };

  handleKeyPress = event => {
    if (event.charCode === 13) {
      event.preventDefault();

      const value = this.state.value.trim();

      if (!value) {
        return false;
      }
    }
  };

  render() {
    const {
      dataSource,
      dataLoading,
      classes,
      label,
      ...restProps
    } = this.props;
    const { value, error, errorMessage, items, focus } = this.state;

    return (
      <div className={classes.root}>
        <TextField
          {...restProps}
          autoComplete={false}
          label={error ? errorMessage : label}
          type="text"
          onKeyPress={this.handleKeyPress}
          onChange={this.handleInputChange}
          onFocus={() => {
            this.setState({ focus: true });
          }}
          onBlur={() => {
            this.setState({ focus: false });
          }}
          value={value}
          error={error}
        />

        {dataSource &&
          !!dataSource.length &&
          focus &&
          value &&
          <List className={classes.list}>
            {dataLoading
              ? <div className={classes.loadingContainer}>
                  <CircularProgress />
                </div>
              : dataSource.map(data =>
                  React.cloneElement(this.props.renderSearchItem(data), {
                    // here, we use onMouseDown rather onClick,
                    // due to TextField onBlur action interrupt click action
                    onMouseDown: this.handleListItemClick(data),
                  })
                )}
          </List>}

        <div className={classes.itemsContainer}>
          {items.map(item =>
            React.cloneElement(this.props.renderItem(item), {
              onRequestDelete: this.handleRemoveItem(item.id),
            })
          )}
        </div>
      </div>
    );
  }
}

export default withStyles(styleSheet)(SearchInput);



// WEBPACK FOOTER //
// ./src/common/components/SearchInput.js